import request from '@/utils/request';

export function submitBatch(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch`,
        method: 'put'
    });
}
export function submitChange(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch/change`,
        method: 'post'
    });
}

export function deleteBatch(gainEid, batchEid) {
    return request({
        url: `/gains/${gainEid}/batch/${batchEid}`,
        method: 'delete'
    });
}

export function batchAllow(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch/allow`,
        method: 'get'
    });
}

export function batchAudit(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch/audit`,
        method: 'put'
    });
}

//退回
export function backBatch(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/batch/back`,
        method: 'put',
        data
    });
}

export function listBatch(gainEid, isChange, desc) {
    return request({
        url: `/gains/${gainEid}/batch/list/${isChange}/${desc}`,
        method: 'get'
    });
}

export function runBatch(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch/run`,
        method: 'put'
    });
}

export function saveBatch(gainEid, data) {
    return request({
        url: `/gains/${gainEid}/batch`,
        method: 'post',
        data: data
    });
}

export function batchChange(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch/change`,
        method: 'get'
    });
}

export function auditChange(gainEid) {
    return request({
        url: `/gains/${gainEid}/batch/audit/change`,
        method: 'put'
    });
}